import {isAuthenticated} from "../../../auth";

export function createCaseCard(block, parent) {
    const blockName = block.data_block_name;
    const blockNumber = getBlockNumber(blockName);

    // Получаем порядковый номер из order + 1
    const displayNumber = block.order !== undefined ? parseInt(block.order, 10) + 1 : 1;

    // Создаем основной контейнер кейса
    const caseCard = document.createElement('div');
    caseCard.className = 'case-slide container-fluid';
    caseCard.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        caseCard.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        caseCard.setAttribute('data-order', String(block.order));
    } else {
        caseCard.setAttribute('data-order', '0');
    }

    caseCard.style.position = 'relative';

    // ВАЖНО: Добавляем атрибуты для работы с news системой
    if (block.news_id) {
        caseCard.setAttribute('data-news-id', block.news_id);
    }
    if (block.news_status) {
        caseCard.setAttribute('data-news-status', block.news_status);
    }
    if (block.news_slug) {
        caseCard.setAttribute('data-news-slug', block.news_slug);
    }

    // Определяем активность ссылки на основе статуса
    const isActiveLink = block.news_status === 'published' || block.id;
    const caseHref = isActiveLink && block.news_slug ? `/case/${block.news_slug}` : '#';

    //language=HTML
    const caseHTML = `
        <!-- Десктопная версия (показывается на md+ экранах) -->
        <div class="desktop-case-view d-none d-md-block">
            <div class="row">
                <div class="col-lg-6 col-md-6 d-flex flex-row justify-content-between">
                    <h3 data-content="${blockName}-title" data-global="true"></h3>
                    <img class="case-slide-image" src="" data-content="${blockName}-cases-image" data-type="image"
                         data-global="true">
                </div>
                <div class="col-lg-6 col-md-6 d-flex flex-row justify-content-between">
                    <div class="case-inner-text">
                        <h4>Проблема:</h4>
                        <p data-content="${blockName}-problem" data-type="textarea" data-global="true"></p>
                        <h4>Рішення BML:</h4>
                        <p data-content="${blockName}-solution" data-type="textarea" data-global="true"></p>
                        <a href="${caseHref}"
                           class="news-link-to-feed-container ${isActiveLink ? 'active' : 'inactive'}">Дізнатися
                            більше</a>
                    </div>
                    <svg class="star-burst star-animated animate" width="38" height="40" viewBox="0 0 38 40" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.5186 38.99C19.4711 39.6322 18.5289 39.6322 18.4814 38.99L17.5271 26.0906C17.4928 25.6263 16.9123 25.4377 16.6116 25.7932L8.25748 35.6681C7.84158 36.1597 7.07937 35.6059 7.4184 35.0584L14.2284 24.0617C14.4736 23.6658 14.1148 23.1721 13.6626 23.2829L1.09965 26.3614C0.474218 26.5147 0.183081 25.6187 0.77915 25.375L12.7523 20.4813C13.1833 20.3052 13.1833 19.6948 12.7523 19.5187L0.779151 14.625C0.183078 14.3813 0.474219 13.4853 1.09965 13.6385L13.6626 16.7171C14.1148 16.8279 14.4736 16.3341 14.2284 15.9383L7.4184 4.94155C7.07936 4.39409 7.84158 3.84031 8.25748 4.33192L16.6116 14.2068C16.9123 14.5623 17.4928 14.3737 17.5272 13.9093L18.4814 1.00996C18.5289 0.36778 19.4711 0.367784 19.5186 1.00997L20.4729 13.9093C20.5072 14.3737 21.0877 14.5623 21.3884 14.2068L29.7425 4.33192C30.1584 3.84031 30.9206 4.3941 30.5816 4.94155L23.7716 15.9383C23.5264 16.3341 23.8852 16.8279 24.3374 16.7171L36.9004 13.6386C37.5258 13.4853 37.8169 14.3813 37.2209 14.625L25.2477 19.5187C24.8167 19.6948 24.8167 20.3052 25.2477 20.4813L37.2209 25.375C37.8169 25.6187 37.5258 26.5147 36.9004 26.3614L24.3374 23.2829C23.8852 23.1721 23.5264 23.6658 23.7716 24.0617L30.5816 35.0584C30.9206 35.6059 30.1584 36.1597 29.7425 35.6681L21.3884 25.7932C21.0877 25.4377 20.5072 25.6263 20.4729 26.0906L19.5186 38.99Z"
                              fill="#0090B8"/>
                    </svg>
                </div>
            </div>
        </div>

        <!-- Мобильная версия аккордеон (показывается на xs-sm экранах) -->
        <div class="mobile-case-accordion d-block d-md-none">
            <div class="accordion-header container-fluid">
                <div class="row align-items-center">
                    <div class="col-12 d-flex align-items-center justify-content-between">
                        <h4 class="header-text-accordion" data-content="${blockName}-title" data-global="true"></h4>
                        <div class="accordion-toggle" aria-label="Розгорнути">
                            <img src="/images/accordion-closed.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion-content collapsed">
                <div class="accordion-content-inner">
                    <div class="image-half">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <h4 class="mobile-header" data-content="${blockName}-title" data-global="true"></h4>
                            <div class="close-accordion" aria-label="Згорнути" type="button">
                                <img src="/images/opened-accordion.svg" alt="">
                            </div>
                        </div>

                        <div class="image-container mb-3">
                            <img class="case-image" src="" alt="" data-content="${blockName}-cases-image"
                                 data-type="image" data-global="true">
                        </div>
                    </div>

                    <div class="description-half">
                        <div class="case-problem-solution">
                            <h5>Проблема:</h5>
                            <p data-content="${blockName}-problem" data-type="textarea" data-global="true"></p>

                            <h5>Рішення BML:</h5>
                            <p data-content="${blockName}-solution" data-type="textarea" data-global="true"></p>
                        </div>

                        <a class="case-link" href="${caseHref}">
                            Дізнатися більше
                        </a>
                    </div>
                </div>
            </div>
        </div>
        ${block.news_status && isAuthenticated() ? `
<div class="news-status-indicator status-${block.news_status}">
    <span class="status-text">${block.news_status.toUpperCase()}</span>
</div>
` : ''}
    `;

    caseCard.innerHTML = caseHTML;

    // Инициализируем функциональность аккордеона для мобильной версии
    setupMobileCaseAccordion(caseCard);

    parent.appendChild(caseCard);
    return caseCard;
}

export function setupMobileCaseAccordion(caseCard) {
    const mobileAccordion = caseCard.querySelector('.mobile-case-accordion');
    if (!mobileAccordion) return;

    const toggleButton = mobileAccordion.querySelector('.accordion-toggle');
    const header = mobileAccordion.querySelector('.accordion-header');
    const content = mobileAccordion.querySelector('.accordion-content');
    const closeButton = mobileAccordion.querySelector('.close-accordion');

    const toggleAccordion = (e) => {
        e.stopPropagation();

        const isCollapsed = content.classList.contains('collapsed');

        // Если раскрываем текущий элемент, закрываем все остальные в той же секции
        if (isCollapsed) {
            const sectionElement = caseCard.parentElement;
            if (sectionElement) {
                const expandedItems = sectionElement.querySelectorAll('.mobile-case-accordion .accordion-content.expanded');
                expandedItems.forEach(item => {
                    if (item !== content) {
                        collapseMobileCaseAccordion(item.closest('.case-slide'));
                    }
                });
            }
        }

        // Переключаем классы для текущего элемента
        content.classList.toggle('collapsed', !isCollapsed);
        content.classList.toggle('expanded', isCollapsed);
        mobileAccordion.classList.toggle('accordion-case-expanded', isCollapsed);

        // Обновляем доступность
        toggleButton.setAttribute('aria-label', isCollapsed ? 'Згорнути' : 'Розгорнути');

        if (isCollapsed) {
            content.style.display = 'block';
            void content.offsetHeight;
            content.style.maxHeight = '3000px';
            content.style.opacity = '1';
            header.style.display = 'none';
        } else {
            content.style.maxHeight = '0';
            content.style.opacity = '0';
            header.style.display = 'block';
            setTimeout(() => {
                if (content.classList.contains('collapsed')) {
                    content.style.display = 'none';
                }
            }, 400);
        }
    };

    // Обработчики событий
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleAccordion);
    }

    if (header) {
        header.addEventListener('click', function (e) {
            if (e.target !== toggleButton && !toggleButton?.contains(e.target)) {
                toggleAccordion(e);
            }
        });
    }

    if (closeButton) {
        closeButton.addEventListener('click', toggleAccordion);
    }

    content.style.maxHeight = '0';
    content.style.opacity = '0';
    content.style.display = 'none';
}

function collapseMobileCaseAccordion(caseCard) {
    const mobileAccordion = caseCard.querySelector('.mobile-case-accordion');
    if (!mobileAccordion) return;

    const header = mobileAccordion.querySelector('.accordion-header');
    const content = mobileAccordion.querySelector('.accordion-content');
    const toggleButton = mobileAccordion.querySelector('.accordion-toggle');

    content.classList.remove('expanded');
    content.classList.add('collapsed');
    mobileAccordion.classList.remove('accordion-case-expanded');

    if (toggleButton) {
        toggleButton.setAttribute('aria-label', 'Розгорнути');
    }

    content.style.maxHeight = '0';
    content.style.opacity = '0';

    if (header) {
        header.style.display = 'block';
    }

    setTimeout(() => {
        if (content.classList.contains('collapsed')) {
            content.style.display = 'none';
        }
    }, 400);
}

// Функция для извлечения номера из имени блока
function getBlockNumber(blockName) {
    const match = blockName.match(/-(\d+)$/);
    return match ? match[1] : '1';
}

export const caseCardProps = {
    name: 'case-card',
    title: 'Картка кейсу',
    description: 'Картка з заголовком, проблемою, рішенням та зображенням',
    allowedParents: ['cases-section'],
    contentFields: [
        {name: 'title', type: 'text', label: 'Заголовок'},
        {name: 'problem', type: 'textarea', label: 'Проблема'},
        {name: 'solution', type: 'textarea', label: 'Рішення BML'},
        {name: 'image', type: 'image', label: 'Зображення'},
        {name: 'link-text', type: 'text', label: 'Текст посилання'}
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview case-card-preview">
                <h3>${data.title || 'Заголовок кейсу'}</h3>
                <div class="row">
                    <div class="col-6">
                        <p><strong>Проблема:</strong> ${data.problem || 'Опис проблеми...'}</p>
                    </div>
                    <div class="col-6">
                        <p><strong>Рішення:</strong> ${data.solution || 'Опис рішення...'}</p>
                    </div>
                </div>
            </div>
        `;
    }
};